import React from 'react';
import './Resume.css';
function Resume() {
  return (
    <section id="resume">
      <h2>Know More</h2>
      <a href="RESUME.pdf" download>Download My Resume</a>
    </section>
  );
}

export default Resume;
